import type { AllListingsFilterElement } from '@b-stock/search-api-client'

import type { DealsRangesConfig } from '@/helpers/featureFlags'

type DealRowData = {
  label: string
  count: number
  dealValue: string
}

/**
 * Builds deal rows from search filter data and deals-ranges flag config.
 * Shared by BestDealsTracker (client) and server-side visibility checks.
 */
export function buildDealRowsFromConfig(
  dealsData: AllListingsFilterElement[] | undefined,
  dealsRangesConfig: DealsRangesConfig | undefined
): DealRowData[] {
  return (['rangeOne', 'rangeTwo', 'rangeThree'] as const)
    .map((rangeKey) => {
      const rangeConfig = dealsRangesConfig?.[rangeKey]

      if (!rangeConfig?.name) return null

      const dealData = dealsData?.find(
        (deal) => deal.value === rangeConfig.name
      )

      return {
        label: rangeConfig.name,
        count: dealData?.count || 0,
        dealValue: rangeConfig.name,
      }
    })
    .filter((row): row is DealRowData => row !== null)
}

export function shouldRenderBestDealsTracker(
  dealsData: AllListingsFilterElement[] | undefined,
  dealsRangesConfig: DealsRangesConfig | undefined
): boolean {
  if (!dealsData || dealsData.length === 0) return false
  return buildDealRowsFromConfig(dealsData, dealsRangesConfig).length > 0
}
